import { CONSTANTS } from '@shared/constants';

export const authConfig: { options: Auth0LockConstructorOptions } = {
  options: {
    theme: {
      logo: '../../../assets/img/login-logo.png',
      primaryColor: '#' + CONSTANTS.BRANDING_COLORS.FOODBACK_BRAND,
    },
    closable: false,
    languageDictionary: {
      signUpSubmitLabel: "Let's get started",
    },
    avatar: null,
    auth: {
      redirect: false,
      sso: false,
    },
    configurationBaseUrl: 'https://cdn.eu.auth0.com',
    container: 'login-auth-container',
  },
};
